export default __webpack_public_path__ + "static/media/thumbnail.175ca271.jpg";